/**
 * Example JavaScript singleton module
 */

var Menu = (function($) {
  function initMenu() {
    // do something
    $("body").toggleClass("has-nav");
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".header-nav").length) {
      return;
    }

    $(".header-hamburger").on("click", function() {
      initMenu();
    });

    $(".header-menu__item").on("click", function() {
      //initMenu();
    });
  }

  return {
    init: init,
  };
})(jQuery);

jQuery(document).ready(Menu.init);
